export default __webpack_public_path__ + "static/media/detalle-del-retiro.645e8519.svg";